import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle, Download, Calendar, MapPin, Ticket } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { mockTickets, mockEvents } from '@/lib/mockData';
import { formatDate, formatTime, formatCurrency } from '@/lib/utils';

export function UserPaymentSuccess() {
  const ticket = mockTickets[0];
  const event = mockEvents.find(e => e.id === ticket.eventId);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <Card className="bg-card border-border p-8 max-w-md w-full text-center">
        {/* Success icon */}
        <div className="w-20 h-20 rounded-full bg-green-500/20 flex items-center justify-center mx-auto mb-6">
          <CheckCircle className="w-12 h-12 text-green-500" />
        </div>
        
        <h1 className="text-2xl font-bold text-white mb-2">Payment Successful!</h1>
        <p className="text-muted-foreground mb-6">Your tickets have been confirmed</p>

        {/* Order details */}
        <Card className="bg-secondary/50 border-border p-4 mb-6 text-left">
          <h3 className="font-semibold text-white mb-3">{ticket.eventTitle}</h3>
          <div className="space-y-2 text-sm">
            <div className="flex items-center gap-2 text-muted-foreground">
              <Calendar className="w-4 h-4" />
              <span>{formatDate(ticket.eventDate)} at {formatTime(ticket.eventDate)}</span>
            </div>
            <div className="flex items-center gap-2 text-muted-foreground">
              <MapPin className="w-4 h-4" />
              <span>{ticket.venue}, {ticket.city}</span>
            </div>
            <div className="flex items-center gap-2 text-muted-foreground">
              <Ticket className="w-4 h-4" />
              <span>{ticket.ticketType} x {ticket.quantity}</span>
            </div>
          </div>
          <div className="border-t border-border mt-3 pt-3">
            <div className="flex justify-between text-white font-semibold">
              <span>Total Paid</span>
              <span>{formatCurrency(ticket.price * ticket.quantity * 1.1)}</span>
            </div>
          </div>
        </Card>

        {/* Confirmation number */}
        <div className="bg-primary/10 rounded-lg p-3 mb-6">
          <p className="text-xs text-muted-foreground mb-1">Confirmation Number</p>
          <p className="text-lg font-mono font-bold text-primary">{ticket.qrCode}</p>
        </div>

        <p className="text-sm text-muted-foreground mb-6">
          A confirmation email has been sent to your email address
        </p>

        {/* Actions */}
        <div className="space-y-3">
          <Link to={`/me/tickets/${ticket.id}`}>
            <Button className="w-full bg-primary text-primary-foreground hover:bg-primary/90">
              View My Ticket
            </Button>
          </Link>
          <Link to="/">
            <Button variant="outline" className="w-full border-border">
              Back to Events
            </Button>
          </Link>
        </div>
      </Card>
    </div>
  );
}

export default UserPaymentSuccess;
